import { useEffect } from 'react'
import { useCookies } from 'react-cookie'
import { useTranslation } from 'react-i18next'

import { LowerRegions } from '@/configs/region'

//NOTE acc. WR-665, on BR site, only show pt-BR locale, on all other sites show pt
export const usePreserveFrench = (region: LowerRegions) => {
  const [cookies, setCookie] = useCookies(['locale'])
  const { i18n } = useTranslation()
  const { language: currentLanguage } = i18n

  useEffect(() => {
    if (region === 'fr') {
      if (
        (currentLanguage !== 'en' || cookies['locale'] !== 'en') &&
        (currentLanguage !== 'fr' || cookies['locale'] !== 'fr')
      ) {
        setTimeout(() => {
          i18n.changeLanguage('en')
        })
      }
    }
  }, [])
}
